import { Injectable } from '@angular/core';

import { Subscription } from 'rxjs';

@Injectable()
export class EventSubscriptionService {
    private registrations: EventGroup[] = [];

    constructor() {

    }

    public configure(component: any): EventGroup {
        if (this.registrations.filter(reg => reg.ContainerName == component).length > 0) {
            return this.getEventGroup(component);
        }
        const group: EventGroup = new EventGroup();
        group.ContainerName = component.constructor.name;
        this.registrations.push(group);
        return group;
    }

    public deregister(component: any): void {
        const group: EventGroup = this.getEventGroup(component);
        for (const subscription of group.Subscriptions) {
            subscription.unsubscribe;
        }

    }

    private getEventGroup(component: any): EventGroup {
        return this.registrations.filter(reg => reg.ContainerName == component.constructor.name)[0];
    }
}

export class EventGroup {
    public ContainerName = '';
    public Subscriptions: Subscription[] = [];

    public Add(subscription: Subscription): EventGroup {
        this.Subscriptions.push(subscription);
        return this;
    }
}
